const widgetSave = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M2.25 14V2h9l2.5 3.3V14zm4.1-1.5h3.4V9.85h-3.4zm2.42-9H6.83v1.78h1.94zm3.53 2.3-1.75-2.3h-.56v2.8H5.6V3.5H3.75v9H5V8.66h6v3.84h1.3z"/></svg>',
};

export { widgetSave as default };
